import { Component, Input } from '@angular/core';
import { AcuseDTO } from '../../class/Acuse.class';
import { AppModule } from '../../../app-module';
import html2canvas from 'html2canvas';
import * as jspdf from 'jspdf';

@Component({
    selector: 'oaj-demanda-detalle-itx',
    templateUrl: 'demanda-detalle.component.html',
    styleUrls: ['./demanda-detalle.component.css'],
    imports: [AppModule]
})

export class DemandaDetalleComponent {
    @Input() acuse: AcuseDTO = new AcuseDTO;

  

    /**
     * Imprime los detalles de la demanda, se obtiene el elemento HTML que contiene los detalles de la demanda, se calculan las dimensiones del contenido y del PDF, se convierte el contenido HTML a una imagen utilizando html2canvas, se crea un nuevo documento PDF utilizando jsPDF, se agrega la imagen al PDF y se guarda el archivo con un nombre basado en el folio de recepción de la demanda
     * @returns 
     */
    printDemanda() {
        const tabla = document.getElementById('areaPrint');

        if (!tabla) {
            console.error('Element with id "areaPrint" not found.');
            return;
        }
        const htmlWidth = tabla.offsetWidth;
        const htmlHeight = tabla.offsetHeight;
        const topLeftMargin = 50;
        const pdfWidth = htmlWidth + (topLeftMargin * 2); // Ancho del PDF
        const pdfHeight = (pdfWidth * 1.5) + (topLeftMargin * 2);
        const canvasImageWidth = htmlWidth;
        const canvasImageHeight = htmlHeight;
        const totalPDFPages = Math.ceil(htmlHeight / pdfHeight) - 1;

        const data = tabla;
        const NameFile = `Acuse-Demanda_${this.acuse.folioRecepcion}.pdf`;
        const pdfPath = NameFile; // Nombre del archivo
        this.convertHtmlToPdf(data, pdfPath, pdfWidth, pdfHeight, topLeftMargin, canvasImageWidth, canvasImageHeight, totalPDFPages);
    }

    /**
     * Convierte el contenido HTML a un documento PDF, se utiliza html2canvas para convertir el contenido HTML a una imagen, luego se crea un nuevo documento PDF utilizando jsPDF, se agrega la imagen al PDF y se guarda el archivo con el nombre especificado
     * @param htmlContent 
     * @param pdfPath 
     * @param pdfWidth 
     * @param pdfHeight 
     * @param topLeftMargin 
     * @param canvasImageWidth 
     * @param canvasImageHeight 
     * @param totalPDFPages 
     */
    convertHtmlToPdf(htmlContent: HTMLElement, pdfPath: string, pdfWidth: number, pdfHeight: number, topLeftMargin: number, canvasImageWidth: number, canvasImageHeight: number, totalPDFPages: number): void {
        html2canvas(htmlContent, { allowTaint: true }).then(canvas => {
            canvas.getContext('2d');
            const imgData = canvas.toDataURL("image/jpeg", 1.0);
            const pdf = new jspdf.jsPDF('p', 'pt', [pdfWidth, pdfHeight]);
            pdf.addImage(imgData, 'png', topLeftMargin, topLeftMargin, canvasImageWidth, canvasImageHeight);

            for (let i = 1; i <= totalPDFPages; i++) {
                pdf.addPage([pdfWidth, pdfHeight], 'p');
                pdf.addImage(imgData, 'png', topLeftMargin, - (pdfHeight * i) + (topLeftMargin * 4), canvasImageWidth, canvasImageHeight);
            }

            pdf.save(`${pdfPath}`);
            // console.log(`PDF saved as ${pdfPath}`);
        });
    }

}